import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';


declare var jQuery: any;

@Component({
    selector: 'evidencias',
    templateUrl: 'evidencias.template.html'
})
export class EvidenciasComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('tooltip') tooltip: ElementRef;

    accion: string;
    subscription: Subscription;
    public filterQuery = "";
    public filterQueryEvidencias = "";
    listaenlaces: any=[];

    listanormas: any=[];
    listaevidencias: any=[];

    normaseleccionada: number = 0;
    evidenciaseleccionada: number = 0;

    detallenorma: boolean = true;
    detalleevidencia: boolean = true;
    formevidencia: boolean = false;

    etiquetaevidencia: string = "";

    iconocerrar: string = 'fa fa-times';
    iconoexpandir: string = 'fa fa-expand';

    copiaevidencia: boolean = false;

    titulonormaenlaces: string = "";

    constructor(private seguridad: SeguridadService,
        private router: Router,
        //private service: PreguntasService,
        private normasService: NormasService,
        private evidenciasService: EvidenciasService,
        private globalEventsManager: GlobalEventsManager,
        private activatedRoute: ActivatedRoute) {

        this.accion = activatedRoute.snapshot.params["accion"];

    }

    ngOnInit() {

      this.seguridad.getLogado();

      this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
          if (mode !== null) {
              if (!mode) {
                  this.router.navigate(['login']);
              }
          }
      });

      this.globalEventsManager.menuExtendido(true);

      this.getListaNormas();

    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
      this.subscription.unsubscribe();
    }

    getListaNormas() {
      this.normasService.getListaNormas().subscribe(
          data => {
            if (data){
              this.listanormas = data.json().lista;
            }
          }
      );
    }



    mostrarEnlaces(enlaces: any, titulo: string) {
      this.listaenlaces = enlaces;
      this.titulonormaenlaces = titulo;
    }


    verNorma(id_norma: number){

      this.resetEvidencia();
      this.detallenorma = false;
      this.normaseleccionada = id_norma;
      this.getListaEvidencias(this.normaseleccionada);

      this.scrollLienzo();
    }

    nuevaEvidencia(){
      this.editarEvidencia(0);
    }

    borrarEvidencia(id_evidencia: number){

      this.evidenciasService.deleteEvidencia(id_evidencia).subscribe(
        data => {
          if (data){
            this.getListaEvidencias(this.normaseleccionada);
          }
        }
      );
    }

    cerrarEvidencia(){

    }

    resetEvidencia(){
      this.listaevidencias = [];
      this.evidenciaseleccionada = 0;
      this.formevidencia = false;
      this.detalleevidencia = true;
    }

    editarEvidencia(id_evidencia:number){
      this.copiaevidencia = false;
      this.getEditarEvidencia(id_evidencia);
    }

    copiarEvidencia(id_evidencia:number){
      this.copiaevidencia = true;
      this.getEditarEvidencia(id_evidencia);
    }

    getEditarEvidencia(id_evidencia: number){
      if (id_evidencia != 0){
        this.etiquetaevidencia = "Editar Evidencia";
      }else{
        this.etiquetaevidencia = "Nueva Evidencia";
      }
      this.detalleevidencia = false;
      this.evidenciaseleccionada = id_evidencia;
      this.formevidencia = true;

      this.scrollLienzo();
    }

    getListaEvidencias(id_norma: number) {
      this.evidenciasService.getListaEvidenciasNorma(id_norma).subscribe(
          data => {
            if (data){
              console.log(data.json());
              this.listaevidencias = data.json().lista;
            }
          }
      );
    }

    onChangeEvidencia(event){
      //if(event){
      if(event.anadir == false){
        this.cerrar(2);
        this.getListaEvidencias(this.normaseleccionada);
      }else{
        this.getListaEvidencias(this.normaseleccionada);
      }
    }

    onCloseEvidencia(event: number){
      this.cerrar(event);
    }


    cerrar(nivel:number){

      //le pasamos el nivel al que tiene que ir

      if (nivel <= 1){
        this.normaseleccionada = 0;
        this.detallenorma = true;
        this.formevidencia = false;
      }

      if (nivel <= 2){
        this.evidenciaseleccionada = 0;
        this.detalleevidencia = true;
        this.formevidencia = false;
      }

      this.scrollLienzo();

    }

    expandir(nivel:number){
      if (nivel == 1){
        (this.detallenorma) ? this.detallenorma = false : this.detallenorma = true;
      }
      if (nivel == 2){
        (this.detalleevidencia) ? this.detalleevidencia = false : this.detalleevidencia = true;
      }
    }

    scrollLienzo(){
      jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
    }

    stripText(val: string){
      var cadena: string = "";

      if (val != null){
        if (val.length>25){
          cadena = val.substr(0, 25)+"...";
        }else{
          cadena = val;
        }
      }

      return cadena;
    }

}



// WEBPACK FOOTER //
// ./src/app/evidencias/evidencias.component.ts